const initialState = null;

const popularAssuredAds = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_POPULAR_ASSURED_ADS_SUCCESS':
			return Object.assign([],state, {...action.payload} );
		case 'GET_POPULAR_ASSURED_ADS_FAILURE':
			return Object.assign([],state, []);
		default:
			return state;
	}
};

export default popularAssuredAds;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/popularAssuredAds.js